module.exports = __webpack_public_path__ + "img/hyperlink.0cf7c22a.png";